"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BubblyBubbles = void 0;

require("./styles.css");

var _jsxRuntime = require("react/jsx-runtime");

var BubblyBubbles = function BubblyBubbles(_ref) {
  var colorStart = _ref.colorStart,
      colorEnd = _ref.colorEnd,
      duration = _ref.duration;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    id: "react-bubbly-transitions__bubbles",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      style: {
        animationDuration: "".concat(duration, "ms"),
        background: colorStart
      },
      className: "react-bubbly-transitions__first"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      style: {
        animationDuration: "".concat(duration, "ms"),
        background: colorEnd
      },
      className: "react-bubbly-transitions__second"
    })]
  });
};

exports.BubblyBubbles = BubblyBubbles;